import { useState, useCallback } from 'react';

export const useCopyToClipboard = (resetDelay = 2000) => {
  const [copiedValue, setCopiedValue] = useState<string | null>(null);

  const copyToClipboard = useCallback(
    (text: string, identifier?: string) => {
      // Create a temporary textarea element (hacky way for iframe)
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      textarea.style.pointerEvents = 'none';

      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);

      try {
        const success = document.execCommand('copy');
        if (success) {
          setCopiedValue(identifier || text);

          setTimeout(() => setCopiedValue(null), resetDelay);
          return true;
        }
        return false;
      } catch (err) {
        console.error('Failed to copy to clipboard:', err);
        return false;
      } finally {
        document.body.removeChild(textarea);
      }
    },
    [resetDelay],
  );

  const isCopied = useCallback(
    (identifier: string) => {
      return copiedValue === identifier;
    },
    [copiedValue],
  );

  return { copyToClipboard, isCopied, copiedValue };
};
